module.exports = __webpack_public_path__ + "static/media/screenshot_1_cropped.6ce3611c.avif";